export const DEFAULT_COUNTRY = 'US';

export const CUSTOMER_FIELD_MAPPING = {
  // Maps AuthContext field names to form field names
  zipCode: 'zip',
  labAccountNumber: 'userId',
};

export const FORM_VALIDATION = {
  required: (val) => {
    if (!val || !val.toString().trim()) return 'Required';
  },
};

export const GRID_SIZES = {
  CUSTOMER_INFO: { lg: 6, xs: 12 },
  DROPSHIP: { lg: 6, xs: 12 },
};

export const BUTTON_STYLES = {
  btnxl: {
    height: '40px',
    margin: '20px 10px',
  },
};

export const ACCOUNT_NUMBER_FIELD_STYLES = {
  '& input[type=number]': {
    '-moz-appearance': 'textfield',
  },
  '& input[type=number]::-webkit-outer-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0,
  },
  '& input[type=number]::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0,
  },
};
